import {
    Component,
    ComponentFactoryResolver,
    Inject,
    Injector,
    OnInit,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { CMPS_DIALOG_DATA } from '@cmps/ng-uikit';

import { TranslationKeyMap } from './event-centre-c-pop-dialog.i18n';
import { CPopMapItem } from './model/c-pop-map-item.model';
import { SwitchContext } from './model/switch-context.model';
import { deflateBase, inflateBase } from './template-inflater';

@Component({
    selector: 'cmps-event-centre-c-pop-dialog',
    templateUrl: './event-centre-c-pop-dialog.component.html',
    host: {
        class: 'cmps-event-centre-c-pop-dialog cmps-cdk-pos-relative cmps-cdk-d-block',
    },
})
export class EventCentreCPopDialogComponent implements OnInit {
    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _ctx: SwitchContext | null;

    @ViewChild('ref', { read: ViewContainerRef, static: true })
    private readonly _ref: ViewContainerRef;

    constructor(
        private readonly _injector: Injector,
        private readonly _factoryResolver: ComponentFactoryResolver,
        @Inject(CMPS_DIALOG_DATA) /** @private */ readonly _data: CPopMapItem[],
    ) {}

    ngOnInit(): void {
        this._switch('right');
    }

    /** @private */
    _onLeftClick(): void {
        this._switch('left');
    }

    /** @private */
    _onRightClick(): void {
        this._switch('right');
    }

    private _switch(direction: 'left' | 'right'): void {
        deflateBase(this._ref);

        const index = this._data.indexOf(this._ctx?.mapItem);
        let nextIndex: number | null = null;
        if (direction === 'left') {
            nextIndex = index - 1 < 0 ? this._data.length - 1 : index - 1;
        }
        if (direction === 'right') {
            nextIndex = index + 1 > this._data.length - 1 ? 0 : index + 1;
        }

        this._ctx = {
            mapItem: this._data?.[nextIndex],
            multiple: this._data.length > 1,
            pos: nextIndex + 1,
            progress: (100 / this._data.length) * (nextIndex + 1),
            length: this._data.length,
        };

        inflateBase(
            this._injector,
            this._factoryResolver,
            this._ref,
            this._ctx,
        );
    }
}
